// extracted by mini-css-extract-plugin
export var active = "_1w-7";
export var backButton = "_1w-6";
export var clone = "_1w-c";
export var collapseBar = "_1w-g";
export var collapseMode = "_1w-i";
export var dragHandle = "_1w-a";
export var dropdownIcon = "_1w-e";
export var hidden = "_1w-o";
export var iconContainer = "_1w-l";
export var iconSwapper = "_1w-n";
export var navItem = "_1w-4";
export var navItemIcon = "_1w-d";
export var navProfile = "_1w-5";
export var notificationDot = "_1w-m";
export var optionsContainer = "_1w-f";
export var primaryNav = "_1w-0";
export var primaryTab = "_1w-j";
export var secondaryNav = "_1w-1";
export var selected = "_1w-k";
export var settingsNav = "_1w-2";
export var settingsNavItems = "_1w-3";
export var show = "_1w-b";
export var sideNav = "_1w-h";
export var teamItem = "_1w-8";
export var userProfileItem = "_1w-9";